// Copyright (c) 2022 by Move Closer

import { ICollection } from '@movecloser/front-core'

import { OrderData, RetryPaymentUrl, SingleOrderData } from '../../../contexts/orders/contracts/orders'

export const OrdersRepositoryType = Symbol.for('IOrdersRepository')

/**
 * @author Wojciech Falkowski <wojciech.falkowski@movecloser.pl>
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export interface IOrdersRepository {
  loadSingleOrder (order: string): Promise<SingleOrderData | null>
  checkOrderPaymentStatus (orderNumber: string): Promise<string>
  loadOrders (currentPage: number, pageSize: number): Promise<{ orders: ICollection<OrderData>; totalCount: number }>
  generateRetryPaymentUrl (orderId: string) : Promise<RetryPaymentUrl>
}
